/**
 * @fileoverview Project status helpers for the Task Tracker (AR-684).
 *
 * The backend `Project#status` enum exposes `finished` for a project the
 * teacher has closed; in the UI that state is presented as "Completed"
 * (the same mapping used by the Arc projects list). Drafts and other
 * statuses are never offered for selection here, so only `finished` is
 * relevant for the tag.
 */

/** Backend status that maps to the "Completed" UI tag. */
export const COMPLETED_PROJECT_STATUS = 'finished'

export function isProjectCompleted(status: string | undefined): boolean {
  return status === COMPLETED_PROJECT_STATUS
}
